const Index = () => import(/* webpackChunkName: "index" */ "../components/Index.vue")
const Record = () => import(/* webpackChunkName: "index" */ "../components/Record.vue")
const InvoiceSelect = () => import(/* webpackChunkName: "index" */ "../components/InvoiceSelect.vue")
const InvoiceTitle = () => import(/* webpackChunkName: "index" */ "../components/InvoiceTitle.vue")
const ApplyResult = () => import(/* webpackChunkName: "index" */ "../components/ApplyResult.vue")
const recordDetail = () => import(/* webpackChunkName: "index" */ "../components/common/recordItem.vue")
const qrCode = () => import(/* webpackChunkName: "index" */ "../components/QRCode.vue")
const SpecialInvoice = () => import(/* webpackChunkName: "index" */ "../components/SpecialInvoice.vue")

export default {
  routes: [
    {
      path: "/",
      component: Index,
      name: "index",
      meta: {
        title: "腾讯充值"
      }
    },
    {
      path: "/record",
      component: Record,
      name: "record",
      meta: {
        title: "开票记录"
      }
    },
    {
      path: "/select",
      component: InvoiceSelect,
      name: "select",
      meta: {
        title: "申请发票"
      }
    },
    {
      path: "/invoiceTitle",
      component: InvoiceTitle,
      name: "invoiceTitle",
      meta: {
        title: "申请发票"
      }
    },
    {
      path: "/applyResult",
      component: ApplyResult,
      name: "applyResult",
      meta: {
        title: "申请发票"
      }
    },
    {
      path: "/recordDetail/:orderId",
      component: recordDetail,
      name: "recordDetail",
      meta: {
        title: "开票记录"
      }
    },
    {
      path: "/qrCode",
      component: qrCode,
      name: "qrCode",
      meta: {
        title: "申请发票"
      }
    },
    {
      path: "/specialInvoiceTitle",
      component: SpecialInvoice,
      name: "specialInvoice",
      meta: {
        title: "申请发票"
      }
    }
  ]
}
